// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"56649b9f","22":"358bf229","157":"55f00cf1","196":"a385a20b","299":"a9fecdd8","311":"4f55c9e4","322":"823ab7d1","472":"65f50dca","661":"02270613","797":"892801a2","954":"61b3e033","967":"b859c3a7"}[chunkId] + ".chunk.js";
};